import { Component } from '@angular/core';
import { CommonService } from 'src/services/common/common.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent {
  constructor(public commonService: CommonService) {}
}
